<template>
  <v-breadcrumbs 
    class="breadcrumbbar liiblack"
    :items="BreadcrumbPaths" 
  >
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
        :to="item.href"
        :disabled="item.disabled"
        v-bind:class="[item.disabled?'text-weight-bold':'breadcrumbactive']"
        active-class="white--text currentpage"
        class="breadcrumb"
        exact
      >

      <span> {{ item.text }} </span>
  
      </v-breadcrumbs-item>
    </template>

    <template v-slot:divider>
      <v-icon color="footergrey"> mdi-chevron-right </v-icon>
    </template>

  </v-breadcrumbs>
</template>

<script>
  export default {
    name: 'BreadCrumb',
    props: {
      BreadcrumbPaths: { 
        type: Array, 
        default() { return [{
          text: 'HKLII',
          disabled: false,
          href: '/',
        }]}
      }
    },
    data(){
        return {
    }}
  }
</script>

<style lang="scss" scoped>
  @import '@/sass/_typography.scss';

  .breadcrumbbar {
    padding: 10px 12px!important;
    border-bottom: 1px solid black !important;
    @media print{
      margin: 0 0px;
    }
  }

  .breadcrumbactive ::v-deep a {
    @include link-no-underline( var(--v-footergrey-base) );
   }

  ::v-deep .currentpage{
    font-weight: 700;
  }

</style>